import { JSONObject } from 'module/types/common';
import { Editor } from '@tiptap/core';
import { InProgressStorageManager } from './inprogress-storage-manager';
import {
  addAskAiSelectionHighlightToReplacedContent,
  replaceSelectionWithContentCommand,
} from './replace-content';
import { setSelection, setSelectionCommand } from '../../../../utils/selection';
import { removeAskAiSelectionHighlightCommand } from '../../../aski-ai-selection-highlight/utils';
import { retainMetaForNode } from '../../utils/replace-content';
import { AskAiCommand, AskAiCommandOptions } from '../types';

export const beforeAskAiCommandStart = (
  editor: Editor,
  command: AskAiCommand,
) => {
  const { addInProgressCommand } = InProgressStorageManager(editor);

  addInProgressCommand(command);
  editor.commands.setEditableByAskAiCommand(false);
};

export const afterAskAiCommandEnd = (editor: Editor, command: AskAiCommand) => {
  const { removeInProgressCommand } = InProgressStorageManager(editor);

  removeInProgressCommand(command);
  editor.commands.setEditableByAskAiCommand(true);
};

export const getAiCommandActionHandler = (
  command: AskAiCommand,
  editor: Editor,
  initialSelection: {
    from: number;
    to: number;
  },
  expandedSelection: {
    from: number;
    to: number;
  },
  options: AskAiCommandOptions,
) => {
  const onCancel = () => {
    afterAskAiCommandEnd(editor, command);
    editor
      .chainWithAskAiActionMeta()
      .command(
        removeAskAiSelectionHighlightCommand(
          expandedSelection.from,
          expandedSelection.to,
        ),
      )
      .command(setSelectionCommand(initialSelection.to, initialSelection.to))
      .focus()
      .run();
  };
  const onComplete = (newContent: JSONObject[]) => {
    afterAskAiCommandEnd(editor, command);
    editor
      .chainWithAskAiActionMeta()
      .command(
        removeAskAiSelectionHighlightCommand(
          expandedSelection.from,
          expandedSelection.to,
        ),
      )
      .command(
        replaceSelectionWithContentCommand(
          newContent,
          expandedSelection.from,
          expandedSelection.to,
          options.contentReplacementOptions ?? {
            retainMetaForNode: retainMetaForNode,
          },
        ),
      )
      .command(({ tr }) => {
        const { to: highlightTo } = addAskAiSelectionHighlightToReplacedContent(
          editor,
          tr,
          expandedSelection.from,
          expandedSelection.to,
        );

        setSelection(tr, highlightTo, highlightTo);

        return true;
      })
      .focus()
      .run();
  };

  return {
    onCancel,
    onComplete,
  };
};
